__turbopack_context__.v({
  "blue-text": "ir2HFG_blue-text",
  "divider": "ir2HFG_divider",
  "stat-grid-container": "ir2HFG_stat-grid-container",
  "stat-grid-element": "ir2HFG_stat-grid-element",
  "stat-grid-sub-grid": "ir2HFG_stat-grid-sub-grid",
  "subtitle": "ir2HFG_subtitle",
});
